import { useEffect } from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';

import { finCalcDataFieldValueAtom } from '../../../Atoms/FinCalcDataFieldValue.atom';
import { getCalculationAtom } from '../../../Atoms/GetCalculation.atom';
import { selectedProductIdAtom } from '../../../Atoms/SelectedProductId.atom';

export const useCalculator = (vehicleId: string) => {
  const getCalculation = useSetAtom(getCalculationAtom(vehicleId));

  const deposit = useAtomValue(finCalcDataFieldValueAtom('deposit'));
  const mileage = useAtomValue(finCalcDataFieldValueAtom('mileage'));
  const terms = useAtomValue(finCalcDataFieldValueAtom('terms'));
  const additionalServices = useAtomValue(finCalcDataFieldValueAtom(`additionalServices`));
  const selectedProductId = useAtomValue(selectedProductIdAtom);
  const vehicle = useAtomValue(currentVehicleAtom);

  useEffect(() => {
    if (vehicle?.pricing?.hasFinance) {
      getCalculation();
    }
  }, [
    vehicle?.heycarId,
    selectedProductId,
    deposit,
    terms?.value,
    mileage?.value,
    additionalServices,
  ]);
};
